import type { CivilDate } from '~/models/civilDate'
import { compareCivilDate } from '~/models/civilDate'

export type BgValidityPeriod = {
  validFrom: CivilDate
  validTo?: CivilDate
}

export type DemandProcurementBgItem = BgValidityPeriod & { bgCode: string }

export function isDemandProcurementBgActiveOn(
  targetDate: CivilDate,
  item: DemandProcurementBgItem,
  bgMasterPeriods: ReadonlyMap<string, BgValidityPeriod>,
): boolean {
  const bgMasterPeriod = bgMasterPeriods.get(item.bgCode)
  if (bgMasterPeriod === undefined) return false
  return isActiveOn(targetDate, item) && isActiveOn(targetDate, bgMasterPeriod)
}

function isActiveOn(targetDate: CivilDate, period: BgValidityPeriod): boolean {
  return (
    compareCivilDate(period.validFrom, targetDate) <= 0 &&
    (period.validTo === undefined ||
      compareCivilDate(targetDate, period.validTo) <= 0)
  )
}
